import ModalPDF from './ModalPDF'

export default ModalPDF
